import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useInView from "../lib/useInView";
import couple from '../images/sky-high-couple.png';
import Carousel from "../components/Carousel";
import sky from '../images/choose-sky.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faLandmarkDome,
    faLandmarkFlag,
} from "@fortawesome/free-solid-svg-icons";
import homeBg from "../images/about_img.png";
import MarketMarquee from "../components/MarketMarque";


const About = () => {
    const navigate = useNavigate();

    // word change animations
    const words = ["Online Banking", "Fintech Solution", "Secure Transactions"];
    const [currentWordIndex, setCurrentWordIndex] = useState(0);

    // Cycle through words every 5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [words.length]);


    // image animation
    const [boxImageRef, boxImageInView] = useInView({ threshold: 0.5 });
    const [box4Ref, box4InView] = useInView({ threshold: 0.7 });
    const [box6Ref, box6InView] = useInView({ threshold: 0.7 });
    const [boxVidRef, boxVidInView] = useInView({ threshold: 0.5 });
    const [heroRef, heroInView] = useInView({ threshold: 0.5 });



    return (
        <>
            <div id="hero-section">
                <div className="hero-section">
                    {/* Left Box: Text and Sub-Boxes */}
                    <div className="hero-text-container">
                        <h1 className="hero-title">
                            We Revolutionize  <span className="handwriting">{words[currentWordIndex]}</span>
                        </h1>
                        <p className="hero-description">
                            We've grown to become one of the largest digital banking providers, committed to inventing, simplifying, and humanizing the banking experience.                        </p>
                        <h2 className="hero-description">
                            Turn your plans into <span className="circle-text">goals</span>
                        </h2>
                    </div>

                </div>

                {/* Display Sliding Carousel */}
                <Carousel />
            </div>
            <MarketMarquee />

            {/* Main About us Section */}
            <div className="two-box-cover coverBG">
                <div className="big-box box">
                    <h2 className="box-title">
                        The Shine Initiative
                    </h2>
                    <p className="box-text">
                        There really is no better example of our commitment to our community than our ongoing dedication to The SHINE Initiative. In 2020, we founded The SHINE Initiative, a non-profit organization which seeks to raise awareness that mental illness in children and young adults is a mainstream health issue.
                    </p>
                    <p className="box-text">
                        Our Directors and colleagues considered what they could to make the meaningful and positive impact on our community. What emerged was a commitment to improving youth mental health. Because to understand something, we must shine the light of understanding and compassion on it.
                    </p>
                    <p className="box-text">
                        In pursuit of this mission, The SHINE Initiative develops funding and strategic alliances through schools to improve public awareness and understanding of mental health issues, research and treatment. The Shine Initiative has raised over $1,000,000 to combat discrimination and to de-stigmatize mental health conditions in youth.
                    </p>
                </div>
                <div className="small-box box">
                    <img
                        ref={heroRef}
                        src={sky}
                        alt="Trust Bank"
                        className={`box-image animate__animated ${heroInView ? "animate__zoomIn" : ""}`}
                    />
                </div>
            </div>


            {/* three column sections */}
            <div className="heading-cover-bg">
                <div className="last-section">
                    {/* Box 1: Text */}
                    <div className="box">
                        <h2 className="box-title">
                            Over 150 Support Teams and more than 50 Partners.                            </h2>
                        <div className="box-text">
                            As an Online Banking, we reserve the right to many different locations to enable us work online and serve better. Also be aware that we may accept deposits and withdrawals using bitcoin or other allowed crypto currencies.
                        </div>
                        <div className="box-text">
                            <h3 className="box-title">
                                Insurance Policies
                            </h3>
                            <>
                               Our Insurance solutions protect you against unexpected expenses from partial or complete damage to you or your properties.
                            </>
                        </div>
                    </div>

                    {/* Box 2: Image */}
                    <div className="box">
                        <img
                            src={homeBg}
                            alt="Couples"
                            ref={boxImageRef}
                            className={`box-image animate__animated ${boxImageInView ? "animate__zoomIn" : ""}`}
                        />
                    </div>

                    {/* Box 3: Icon, Heading, and Text */}
                    <div className="box">
                        <div
                            ref={box6Ref}
                            className={`icon-title-text-container animate__animated ${box6InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faLandmarkFlag} className="box-icon" />
                            <div
                                className="title-text">
                                <h3 className="box-title">
                                    Online Banking
                                </h3>
                                <div className="box-text">
                                    When you use any of our e-banking products - online banking, credit and debit cards, you are assured of its security. We offer a secure internet banking platforms for online transactions and e-payments.                                </div>
                            </div>
                        </div>


                        <div
                            ref={box4Ref}
                            className={`icon-title-text-container animate__animated ${box4InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faLandmarkDome} className="box-icon" />
                            <div className="title-text">
                                <h3 className="box-title">
                                    Loans & Mortgages
                                </h3>
                                <div className="box-text">
                                    We strive to help you achieve your financial goals with our flexible financing.We've got a variety of mortgage products to choose from which we've built with your needs in mind.                                </div>
                            </div>
                        </div>

                        <button
                            onClick={() => navigate("/contact-us")}
                            className="delete-button">
                            Contact Support
                        </button>
                    </div>
                </div>

            </div>

            {/* The last section */}
            <div className="video-section">
                <div
                    ref={boxVidRef}
                    className={`hero-image-container animate__animated ${boxVidInView ? "animate__zoomIn" : ""}`}
                >
                    <img src={couple} alt="" className="box-image" />

                </div>

                <div className="hero-text-container">
                    <h2 className="box-title"> Care, Clarity, and Confidence</h2>
                    <h2 className="hero-title">
                        We want to show you what it’s like to be with a bank that cares.
                    </h2>

                    <button
                        onClick={() => navigate("/login")}
                        className="delete-button">
                        Get Started
                    </button>
                </div>
            </div>
        </>
    );
}

export default About;
